module.exports = __webpack_public_path__ + "static/media/main_visual_compact_track_loaders_2100_rt_nxt3_manitou.f3949f27.png";